import type {LogName} from "./types/logname";
import {AppType, appType} from "../helper/appInfo";

export function log(message: string, logName: LogName) {
    if (appType() == AppType.ANDROID) {
        window.o_apps_android?.errorLogging?.(logName, message);
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.errorLogging?.postMessage(
            {
                logName: logName,
                message: message
            }
        );
    }
}